<template>
  <div>
    <vx-card class="mt-10">
      <table>
        <tr>
          <td>
            <vs-input
              :label="$t('pilihExcelFile')"
              type="file"
              size="small"
              accept=".xlsx"
              @change="previewFiles"
            />
            &nbsp;
          </td>
          <td>
            <vs-button
              icon-pack="feather"
              icon="icon-arrow-down"
              color="primary"
              size="small"
              class="ml-5"
              @click="exportExcel"
            >
              {{ $t("downloadFormat").toUpperCase() }}</vs-button
            >
          </td>
          <td>
            <vs-alert color="primary" active="true" class="ml-3">
              {{ $t("dataUpload") }} {{ excelData.length }}
            </vs-alert>
          </td>
          <td>
            <vs-alert color="success" active="true" class="ml-3">
              {{ $t("dataStatusBerhasil") }} {{ dataSukses.length }}
            </vs-alert>
          </td>
          <td>
            <vs-alert color="danger" active="true" class="ml-3">
              {{ $t("dataStatusGagal") }} {{ dataGagal.length }}
            </vs-alert>
          </td>
          <td>
            <vs-alert
              color="warning"
              active="true"
              class="ml-3"
              v-if="excelData.length > 0"
            >
              Data Yang diupload hanyalah data yang statusnya BERHASIL
            </vs-alert>
          </td>
          <td class="ml-3">
            <el-select
              @input="changeAction"
              class="ml-5"
              size="small"
              v-model="actionUpload"
              filterable
              placeholder="Select"
            >
              <el-option
                v-for="item in optionsAction"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </td>
        </tr>
      </table>
      <div style="height: 90vh">
        <vxe-table
          v-if="actionUpload == 'upload'"
          :loading="loadingTable"
          empty-text="Empty Data "
          keep-source
          border
          show-overflow
          show-header-overflow
          ref="xTable"
          height="90%"
          size="mini"
          row-key
          highlight-hover-row
          highlight-current-row
          :row-config="{ isCurrent: true, isHover: true, height: 35 }"
          :column-config="{ resizable: true }"
          :data="excelData"
          :mouse-config="{ selected: true }"
          :checkbox-config="{
            highlight: true,
            range: true,
          }"
          :keyboard-config="{
            isArrow: true,
            isDel: true,
            isEnter: true,
            isTab: true,
            isEdit: true,
          }"
          :edit-config="{
            trigger: 'dblclick',
            mode: 'cell',
            showStatus: true,
          }"
          :scroll-y="{ mode: 'wheel' }"
          @cell-click="cellClickEvent"
        >
          <vxe-column type="seq" width="60"></vxe-column>
          <vxe-column
            width="100"
            field="info"
            title="STATUS"
            header-align="center"
            sortable
            :filters="[
              { label: 'Berhasil', value: 'Berhasil' },
              { label: 'Gagal', value: 'Gagal' },
            ]"
            :filter-method="filterInfo"
          >
          </vxe-column>
          <vxe-column
            width="250"
            field="noAju"
            title="NO AJU"
            header-align="center"
            :filters="[{ data: '' }]"
            :filter-method="filterDokumen"
          >
            <template v-slot:filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>
          <vxe-column
            width="100"
            field="idDokumen"
            title="JENIS DOKUMEN"
            header-align="center"
            :filters="[{ data: '' }]"
            :filter-method="filterDokumen"
          >
            <template v-slot:filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>
          <vxe-column
            width="150"
            field="noUrut"
            title="NO PENDAFTARAN"
            align="center"
            :filters="[{ data: '' }]"
            :filter-method="filterDokumen"
          >
            <template v-slot:filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>
          <vxe-column
            width="150"
            field="tglDokumen"
            title="TANGGAL DOKUMEN"
            align="center"
            :formatter="$$formatDate"
          >
          </vxe-column>
          <vxe-column
            v-show="!$store.state.noDeliveryInDetail"
            width="150"
            field="noDelivery"
            title="NO DELIVERY"
            header-align="center"
            :filters="[{ data: '' }]"
            :filter-method="filterDokumen"
          >
            <template v-slot:filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>
          <vxe-column
            width="150"
            field="noSuratJalan"
            title="NO SURAT JALAN"
            header-align="center"
            :filters="[{ data: '' }]"
            :filter-method="filterDokumen"
          >
            <template v-slot:filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>
          <vxe-column
            width="150"
            field="noAwb"
            title="NO AWB"
            header-align="center"
            :filters="[{ data: '' }]"
            :filter-method="filterDokumen"
          >
            <template v-slot:filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>
          <vxe-column
            width="150"
            field="noPacking"
            title="NO PACKING LIST"
            header-align="center"
            :filters="[{ data: '' }]"
            :filter-method="filterDokumen"
          >
            <template v-slot:filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>
          <vxe-column
            width="150"
            field="noInvoice"
            title="NO INVOICE"
            header-align="center"
            :filters="[{ data: '' }]"
            :filter-method="filterDokumen"
          >
            <template v-slot:filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>
          <vxe-column
            width="150"
            field="noKontrak"
            title="NO KONTRAK"
            header-align="center"
            :filters="[{ data: '' }]"
            :filter-method="filterDokumen"
          >
            <template v-slot:filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>
          <vxe-column
            width="150"
            field="tglInvoice"
            title="TANGGAL INVOICE"
            align="center"
            :formatter="$$formatDate"
          >
          </vxe-column>
          <vxe-column
            width="150"
            field="tglKeluar"
            title="TANGGAL PENGELUARAN"
            align="center"
            :formatter="$$formatDate"
          >
          </vxe-column>
          <vxe-column
            width="150"
            field="customer"
            title="PENERIMA"
            header-align="center"
            :filters="[{ data: '' }]"
            :filter-method="filterDokumen"
          >
            <template v-slot:filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>
          <vxe-column
            width="150"
            field="noWo"
            title="NO WO/PO CUSTOMER"
            header-align="center"
          >
          </vxe-column>
          <vxe-column
            width="150"
            field="totalPacking"
            title="TOTAL PACKAGING"
            header-align="center"
          >
          </vxe-column>
          <vxe-column
            width="150"
            field="satuanPacking"
            title="SATUAN PACKAGING"
            header-align="center"
          >
          </vxe-column>
          <vxe-column
            width="150"
            field="netWeight"
            title="NET"
            header-align="center"
          >
          </vxe-column>
          <vxe-column
            width="150"
            field="grossWeight"
            title="GROSS"
            header-align="center"
          >
          </vxe-column>
          <vxe-column
            width="150"
            field="measure"
            title="MEASUREMENT"
            header-align="center"
          >
          </vxe-column>
          <vxe-column
            width="150"
            field="remark"
            title="REMARK"
            header-align="center"
          >
          </vxe-column>
          <vxe-table-column
            align="center"
            field="currency"
            title="CURRENCY"
          ></vxe-table-column>
          <vxe-table-column
            align="center"
            field="kurs"
            title="KURS"
          ></vxe-table-column>
        </vxe-table>
      </div>
      <TableFull v-if="actionUpload == 'update'" :tableConfig="tableConfig" />

      <vs-button
        class="mt-5"
        v-if="excelData.length > 0 || tableConfig.tableData.length > 0"
        transparent
        size="medium"
        icon-pack="feather"
        icon="icon-save"
        color="primary"
        @click="confirmUpload()"
        >Simpan</vs-button
      >
    </vx-card>

    <vxe-modal
      v-model="showDetails"
      :title="'Barang dari dokumen ' + selectRow.noUrut"
      width="800"
      height="400"
      :mask="false"
      :lock-view="false"
      resize
    >
      <template v-slot>
        <vxe-table
          class="mytable-footer"
          border
          auto-resize
          show-overflow
          show-header-overflow
          show-footer
          highlight-hover-row
          size="mini"
          height="auto"
          :sync-resize="showDetails"
          :row-config="{ isCurrent: true, isHover: true, height: 35 }"
          :column-config="{ resizable: true }"
          :keyboard-config="{
            isArrow: true,
            isDel: true,
            isEnter: true,
            isTab: true,
            isEdit: true,
          }"
          :data="selectRow.listDetail"
          :footer-method="footerMethod"
          :toolbar-config="tableToolbar"
        >
          <vxe-table-column
            field="info"
            title="STATUS"
            align="center"
            width="80"
          ></vxe-table-column>
          <vxe-table-column
            field="seriBarang"
            title="Seri Barang"
            align="center"
            width="80"
          ></vxe-table-column>
          <vxe-table-column
            field="kodeBarang"
            title="KODE BARANG"
          ></vxe-table-column>
          <vxe-table-column
            field="namaBarang"
            title="NAMA BARANG"
          ></vxe-table-column>
          <vxe-table-column field="satuan" title="SATUAN"></vxe-table-column>
          <vxe-table-column field="style" title="STYLE"></vxe-table-column>
          <vxe-table-column field="color" title="COLOR"></vxe-table-column>
          <vxe-table-column field="size" title="SIZE"></vxe-table-column>
          <vxe-table-column field="spec" title="SPEC"></vxe-table-column>
          <vxe-table-column
            field="jmlKeluar"
            :formatter="$$formatAmountBc"
            title="QTY"
          ></vxe-table-column>
          <vxe-table-column
            field="amount"
            :formatter="$$formatAmountBc"
            title="NILAI CMT"
          ></vxe-table-column>
          <vxe-table-column
            field="amountFob"
            :formatter="$$formatAmountBc"
            title="NILAI FOB"
          ></vxe-table-column>
          <vxe-table-column
            align="center"
            field="currency"
            title="CURRENCY"
          ></vxe-table-column>
          <vxe-table-column
            align="center"
            field="kurs"
            title="KURS"
          ></vxe-table-column>
          <vxe-column
            v-show="$store.state.noDeliveryInDetail"
            width="150"
            field="noDelivery"
            title="NO DELIVERY"
            header-align="center"
            :filters="[{ data: '' }]"
            :filter-method="filterDokumen"
          >
            <template v-slot:filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>
        </vxe-table>
      </template>
    </vxe-modal>
  </div>
</template>
<script>
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import TableFull from "../../components/general/TableFull.vue";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";

import XLSX from "xlsx";

import moment from "moment";
export default {
  props: {
    test: String,
    method: {
      type: Function,
    },
  },
  components: {
    PerfectScrollbar,
    SweetModal,
    SweetModalTab,

    TableFull,
  },
  data() {
    return {
      tableConfig: {
        bodyOverflow: false,
        headerOverflow: false,
        checkbox: false,
        select: false,
        selectTitle: this.$t("detailItem"),
        selectButton: this.$t("check"),
        tableName: "tableBarang",

        tableHeight: 450,
        rowHeight: 35,
        tableData: [],
        size: "mini",

        column: [
          {
            field: "info",
            key: "info",
            title: "STATUS",
            width: 200,
            align: "left",
          },
          {
            field: "noAju",
            key: "noAju",
            title: "NO AJU",
            width: 200,
            align: "left",
          },
          {
            field: "idDokumen",
            key: "idDokumen",
            title: "JENIS DOKUMEN",
            width: 200,
            align: "left",
          },
          {
            field: "noUrut",
            key: "noUrut",
            title: "NO DOKUMEN",
            width: 200,
            align: "left",
          },
          {
            field: "tglDokumen",
            key: "tglDokumen",
            title: "TGL DOKUMEN",
            width: 200,
            align: "left",
          },
          {
            field: "kodeBarang",
            key: "kodeBarang",
            title: "KODE BARANG",
            width: 150,
            align: "left",
          },
          {
            field: "namaBarang",
            key: "namaBarang",
            title: "NAMA BARANG",
            width: 150,
            align: "left",
          },
          {
            field: "satuan",
            key: "satuan",
            title: "SATUAN",
            width: 150,
            align: "left",
          },
          {
            field: "currency",
            key: "currency",
            title: "CURRENCY",
            width: 150,
            align: "left",
          },
          {
            field: "jmlKeluar",
            key: "jmlKeluar",
            title: "QTY DOK",
            width: 150,
            align: "left",
          },
          {
            field: "amount",
            key: "amount",
            title: "AMOUNT CMT",
            width: 150,
            align: "left",
          },
          {
            field: "amountFob",
            key: "amountFob",
            title: "AMOUNT FOB",
            width: 150,
            align: "left",
          },
        ],
      },
      actionUpload: "upload",
      optionsAction: [
        { label: "Upload", value: "upload" },
        { label: "Perbarui", value: "update" },
      ],
      tableToolbar: {
        export: true,
        zoom: true,
      },
      showDetails: false,
      index: "",
      loadingTable: false,
      noreg: "",
      remark: "",
      tglInput: new Date().toLocaleString("en-US", {
        timeZone: "Asia/Jakarta",
      }),
      excelData: [],
      dataSukses: [],
      dataGagal: [],
      dataUpload: [],
      userId: "",
      noBap: "",
      datastok: [],
      contacts: [],
      selectRow: {},
      format: "yyyy-MM-dd",
    };
  },
  methods: {
    changeAction(val) {
      console.log(val);
      this.excelData = [];
    },
    formatterDate({ cellValue }) {
      return moment(cellValue).format("yyyy-MM-DD");
    },
    formatDate(cell) {
      return moment(cell).format("yyyy-MM-DD");
    },
    filterInfo({ value, row, column }) {
      // console.log(value);
      if (value == "Gagal") {
        return row.info != "Berhasil";
      } else {
        return row.info == value;
      }
    },
    filterDokumen({ option, row }) {
      return row.noUrut === Number(option.data);
    },
    formatterNum({ cellValue }) {
      return cellValue.toFixed(2);
    },
    cellClickEvent({ row }) {
      this.showDetails = true;
      this.selectRow = row;
    },
    getReg(urut) {
      var date = new Date();
      var day = date.getDate();
      if (day < 10) day = "0" + day;
      var month = (date.getMonth() + 1).toString().padStart(2, "0");
      var year = date.getFullYear();

      var hour = date.getHours();
      var minutes = date.getMinutes();
      var sec = date.getSeconds();

      var seedatetime =
        "IN-" + year + month + day + "-" + hour + minutes + sec + urut;

      return seedatetime;
    },
    confirmUpload() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Apakah Yakin?`,
        text: `Upload data yang berhasil ?`,
        accept: async () => {
          this.uploadAll();
        },
      });
    },

    async uploadAllUpdate() {
      try {
        this.$vs.loading({ text: "Mohon tunggu, sedang melakukan Upload" });
        this.tableConfig.tableData = this.tableConfig.tableData.filter(
          (f) => f.info == "Berhasil"
        );

        let post = await this.$api.post(
          "api/v1/delivery/dokumenkeluar/updateall",
          this.tableConfig.tableData
        );
        if (post.data.status == "validation") {
          return this.notifValidasi(post.data.message, true);
        }

        setTimeout(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: "Update Pengeluaran Dokumen",
            title: this.$t("berhasil"),
            color: "success",
          });
          this.$router.push("/exim/dokumenkeluar");
        }, 1);
      } catch (error) {
        this.$vs.loading.close();
        console.log(error);
        this.$vs.loading({ text: "Error: Hubungi developer" });
      }
    },
    async uploadAll() {
      try {
        if (this.actionUpload == "update") {
          this.uploadAllUpdate();
          return;
        }
        this.$vs.loading({ text: "Mohon tunggu, sedang melakukan Upload" });
        this.excelData = this.excelData.filter((f) => f.info == "Berhasil");

        let post = await this.$api.post(
          "api/v1/delivery/dokumenkeluar/uploadall",
          this.excelData
        );
        if (post.data.status == "error") {
          throw post.data.message;
          return;
        }

        if (post.data.status == "validation") {
          this.notifValidasi(post.data.message, true, 5000);
          this.$vs.loading.close();
          return;
        }

        setTimeout(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: "Upload Pengeluaran Dokumen",
            title: this.$t("berhasil"),
            color: "success",
          });
          this.$router.push("/exim/dokumenkeluar");
        }, 1);
      } catch (error) {
        this.$vs.loading.close();
        console.log(error);
        this.$vs.loading({ text: "Error: Hubungi developer" });
      }
    },
    exportExcel() {
      let title = "Format Upload Pengeluaran Dokumen.xlsx";
      let headers = [
        {
          "NO DELIVERY": "",
          "NO AJU": "",
          "JENIS DOC": "",
          "NO PENDAFTARAN": "",
          "TANGGAL DOKUMEN (YYYY-MM-DD)": "",
          "TANGGAL KELUAR (YYYY-MM-DD)": "",
          "NO INVOICE": "",
          "NO KONTRAK": "",
          "TANGGAL INVOICE (YYYY-MM-DD)": "",
          "NO SURAT JALAN": "",
          "NO PACKING LIST": "",
          PENERIMA: "",
          "SERI BARANG": "",
          "KODE BARANG": "",
          "NAMA BARANG": "",
          SATUAN: "",
          STYLE: "",
          COLOR: "",
          SIZE: "",
          SPEC: "",
          JUMLAH: "",
          CURRENCY: "",
          "NILAI KURS": "",
          "NILAI BARANG CMT": "",
          "NILAI BARANG FOB": "",
          "NO WO/PO CUSTOMER": "",
          "NO POL/MOBIL": "",
          "QTY PACKAGING": "",
          "SATUAN PACKAGING": "",
          REMARK: "",
          "NO AWB": "",
          NET: "",
          GROSS: "",
          MEASUREMENT: "",
        },
      ];
      if (this.actionUpload == "update") {
        headers = [
          {
            "NO AJU": "",
            "JENIS DOC": "",
            "NO PENDAFTARAN": "",
            "TANGGAL DOKUMEN (YYYY-MM-DD)": "",

            "SERI BARANG": "",
            "KODE BARANG": "",
            "NAMA BARANG": "",
            SATUAN: "",

            JUMLAH: "",
            CURRENCY: "",
            "NILAI BARANG CMT": "",
            "NILAI BARANG FOB": "",
          },
        ];
        title = "Format upload Update Document.xlsx";
      }

      const data = XLSX.utils.json_to_sheet(headers);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, title);
    },
    async previewFilesUpdate(e) {
      const file = e.target.files[0];
      var reader = new FileReader();
      this.tableConfig.tableData = [];
      let tmp0 = [];
      let t = this;
      this.loadingTable = true;
      try {
        reader.onload = function (e) {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {
            type: "array",
          });
          var firstSheet = workbook.SheetNames[0];
          const elements = XLSX.utils.sheet_to_json(
            workbook.Sheets[firstSheet]
          );
          // console.log("Excel read OK!");
          // console.log("Found " + elements.length + " elements");
          // console.log("JSON size", JSON.stringify(elements).length, "bytes");
          // console.log(elements);
          elements.forEach((el, i) => {
            t.tableConfig.tableData.push({
              noAju: el["NO AJU"],
              idDokumen: el["JENIS DOC"],
              noUrut: el["NO PENDAFTARAN"],
              tglDokumen: el["TANGGAL DOKUMEN (YYYY-MM-DD)"],
              seriBarang: el["SERI BARANG"],
              kodeBarang: el["KODE BARANG"],
              namaBarang: el["NAMA BARANG"],
              satuan: el["SATUAN"],
              jmlKeluar: el["JUMLAH"],
              currency: el["CURRENCY"],
              kurs: el["NILAI KURS"],
              amount: el["NILAI BARANG CMT"],
              amountFob: el["NILAI BARANG FOB"],
              index: i,
              info: "Berhasil",
            });
          });
          setTimeout(() => {
            t.validasiDataUpdate();
          }, 1000);
          t.loadingTable = false;
        };
        // this.excelData = JSON.parse(JSON.stringify(tmp0));

        this.loadingTable = false;
        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.log(error);
      }
    },
    async previewFiles(e) {
      if (this.actionUpload == "update") {
        this.previewFilesUpdate(e);
        return;
      }
      const file = e.target.files[0];
      var reader = new FileReader();
      this.excelData = [];
      let tmp0 = [];
      let t = this;
      this.loadingTable = true;
      try {
        reader.onload = function (e) {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {
            type: "array",
          });
          var firstSheet = workbook.SheetNames[0];
          const elements = XLSX.utils.sheet_to_json(
            workbook.Sheets[firstSheet]
          );
          // console.log("Excel read OK!");
          // console.log("Found " + elements.length + " elements");
          // console.log("JSON size", JSON.stringify(elements).length, "bytes");
          // console.log(elements);
          elements.forEach((el, i) => {
            t.excelData.push({
              noDelivery: el["NO DELIVERY"],
              noAju: el["NO AJU"],
              idDokumen: el["JENIS DOC"],
              noUrut: el["NO PENDAFTARAN"],
              tglDokumen: el["TANGGAL DOKUMEN (YYYY-MM-DD)"],
              tglKeluar: el["TANGGAL KELUAR (YYYY-MM-DD)"],
              noInvoice: el["NO INVOICE"],
              noKontrak: el["NO KONTRAK"],
              noSuratJalan: el["NO SURAT JALAN"],
              noPacking: el["NO PACKING LIST"],
              tglInvoice: el["TANGGAL INVOICE (YYYY-MM-DD)"],
              customer: el["PENERIMA"],
              seriBarang: el["SERI BARANG"],
              kodeBarang: el["KODE BARANG"],
              namaBarang: el["NAMA BARANG"],
              satuan: el["SATUAN"],
              style: el["STYLE"],
              color: el["COLOR"],
              size: el["SIZE"],
              spec: el["SPEC"],
              jmlKeluar: el["JUMLAH"],
              currency: el["CURRENCY"],
              kurs: el["NILAI KURS"],
              amount: el["NILAI BARANG CMT"],
              amountFob: el["NILAI BARANG FOB"],
              noWo: el["NO WO/PO CUSTOMER"],
              noPol: el["NO POL/MOBIL"],
              netWeight: el["NET"],
              grossWeight: el["GROSS"],
              totalPacking: el["QTY PACKAGING"],
              satuanPacking: el["SATUAN PACKAGING"],
              measure: el["MEASUREMENT"],
              remark: el["REMARK"],
              noAwb: el["NO AWB"],
              index: i,
              info: "Berhasil",
            });
          });
          setTimeout(() => {
            t.validasiData1();
          }, 1000);
          t.loadingTable = false;
        };
        // this.excelData = JSON.parse(JSON.stringify(tmp0));

        this.loadingTable = false;
        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.log(error);
      }
    },

    async validasiDataUpdate() {
      try {
        // this.$vs.loading();
        this.loadingTable = true;
        this.$vs.notify({
          text: "Validation 1",
          color: "success",
          title: this.$t("berhasil"),
          iconPack: "feather",
          icon: "icon-check",
          time: 4000,
        });

        // let data = this.excelData[0];

        this.tableConfig.tableData.forEach((e) => {
          if (!e.amountFob) e.amountFob = 0;
          if (!e.amount) e.amount = 0;
          // if (!e.noAju) e.info = "No Aju Gagal";

          // if (!e.idDokumen) e.info = "Jenis Dokumen Gagal";

          if (!e.noUrut) e.info = "No Pendaftaran Gagal";
          // if (!e.customer) e.info = "Penerima Gagal";
          e.kodeCustomer = e.customer;

          if (!e.kodeBarang) e.info = "Kode Barang Gagal";
          // if (
          //   validasi.includes(e.seriBarang) ||
          //   isNaN(parseInt(e.seriBarang))
          // ) {
          //   e.info = "Seri Barang Gagal";
          // }
          if (!e.jmlKeluar || isNaN(parseFloat(e.jmlKeluar))) {
            e.info = "Jml Keluar Gagal";
          }
          console.log(e.amount);
          if (!e.amount || isNaN(parseFloat(e.amount))) {
            if (e.amount != 0) {
              e.info = "Nilai Gagal";
            }
          }

          // if (
          //   validasi.includes(e.tglDokumen) ||
          //   validasi.includes(e.tglKeluar)
          // ) {
          //   e.info = "Tanggal Gagal";
          // } else {
          //   e.tglDokumen = moment(this.ExcelDateToJSDate(e.tglDokumen)).format(
          //     "yyyy-MM-DD"
          //   );

          //   e.tglKeluar = moment(this.ExcelDateToJSDate(e.tglKeluar)).format(
          //     "yyyy-MM-DD"
          //   );
          // }

          // if (e.tglDokumen == "Invalid date" || e.tglKeluar == "Invalid date") {
          //   e.info = "Tanggal Gagal";
          // } else {
          //   e.tglDokumen = new Date(e.tglDokumen);
          //   e.tglKeluar = new Date(e.tglKeluar);
          // }

          e.amount = parseFloat(e.amount);
          e.jmlKeluar = parseFloat(e.jmlKeluar);
          e.price = e.amount / e.jmlKeluar;
          e.harga = e.amount / e.jmlKeluar;
          e.hargaFob = e.amountFob / e.jmlKeluar;
        });

        this.loadingTable = false;

        this.$vs.loading.close();
      } catch (error) {
        console.log(error);
        this.loadingTable = false;
        this.$vs.loading({ text: "error: hubungi developer" });
      }
    },
    async validasiData1() {
      try {
        let validasi = ["", null, undefined];
        // this.$vs.loading();
        this.loadingTable = true;
        this.$vs.notify({
          text: "Validation 1",
          color: "success",
          title: this.$t("berhasil"),
          iconPack: "feather",
          icon: "icon-check",
          time: 4000,
        });

        // let data = this.excelData[0];

        this.excelData.forEach((e) => {
          if (!e.amountFob) e.amountFob = 0;
          if (!e.amount) e.amount = 0;
          if (validasi.includes(e.noAju)) e.info = "No Aju Gagal";

          // if (validasi.includes(e.idDokumen)) e.info = "Jenis Dokumen Gagal";

          if (validasi.includes(e.noUrut)) e.info = "No Pendaftaran Gagal";
          if (validasi.includes(e.customer)) e.info = "Penerima Gagal";
          e.kodeCustomer = e.customer;

          if (validasi.includes(e.kodeBarang)) e.info = "Kode Barang Gagal";
          // if (
          //   validasi.includes(e.seriBarang) ||
          //   isNaN(parseInt(e.seriBarang))
          // ) {
          //   e.info = "Seri Barang Gagal";
          // }
          if (
            validasi.includes(e.jmlKeluar) ||
            isNaN(parseFloat(e.jmlKeluar))
          ) {
            e.info = "Jml Keluar Gagal";
          }
          if (validasi.includes(e.amount) || isNaN(parseFloat(e.amount))) {
            if (e.amount != 0) {
              e.info = "Nilai Gagal";
            }
          }

          if (validasi.includes(e.namaBarang)) e.info = "Nama Barang Gagal";
          if (validasi.includes(e.satuan)) e.info = "Satuan Gagal";
          if (validasi.includes(e.tglDokumen)) {
            e.info = "Tanggal DOKUMEN Gagal";
          } else {
            if (typeof e.tglDokumen == "number") {
              e.tglDokumen = moment(
                this.ExcelDateToJSDate(e.tglDokumen)
              ).format("yyyy-MM-DD");
            } else {
              e.tglDokumen = moment(e.tglDokumen).format("yyyy-MM-DD");
            }
          }
          if (e.tglDokumen == "Invalid date") {
            e.info = "Tanggal Gagal";
          } else {
            let tgldok = new Date(e.tglDokumen);
            e.tglDokumen = tgldok;
          }
          if (validasi.includes(e.tglKeluar)) {
            e.info = "Tanggal INVOICE Gagal";
          } else {
            if (!validasi.includes(e.tglInvoice)) {
              if (typeof e.tglInvoice == "number") {
                e.tglInvoice = moment(
                  this.ExcelDateToJSDate(e.tglInvoice)
                ).format("yyyy-MM-DD");
              } else {
                e.tglInvoice = moment(e.tglInvoice).format("yyyy-MM-DD");
              }
            }
          }
          if (!validasi.includes(e.tglInvoice)) {
            if (typeof e.tglInvoice == "number") {
              e.tglInvoice = moment(
                this.ExcelDateToJSDate(e.tglInvoice)
              ).format("yyyy-MM-DD");
            } else {
              e.tglInvoice = moment(e.tglInvoice).format("yyyy-MM-DD");
            }
          }
          // if (
          //   validasi.includes(e.tglDokumen) ||
          //   validasi.includes(e.tglKeluar)
          // ) {
          //   e.info = "Tanggal Gagal";
          // } else {
          //   e.tglDokumen = moment(this.ExcelDateToJSDate(e.tglDokumen)).format(
          //     "yyyy-MM-DD"
          //   );

          //   e.tglKeluar = moment(this.ExcelDateToJSDate(e.tglKeluar)).format(
          //     "yyyy-MM-DD"
          //   );
          // }

          if (e.tglDokumen == "Invalid date" || e.tglKeluar == "Invalid date") {
            e.info = "Tanggal Gagal";
          } else {
            e.tglDokumen = new Date(e.tglDokumen);
            e.tglKeluar = new Date(e.tglKeluar);
          }

          // if (e.tglInvoice) {
          //   e.tglInvoice = moment(this.ExcelDateToJSDate(e.tglInvoice)).format(
          //     "yyyy-MM-DD"
          //   );

          //   e.tglInvoice = new Date(e.tglInvoice);
          // }

          e.amount = parseFloat(e.amount);
          e.jmlKeluar = parseFloat(e.jmlKeluar);
          e.price = e.amount / e.jmlKeluar;
          e.harga = e.amount / e.jmlKeluar;
          e.hargaFob = e.amountFob / e.jmlKeluar;
        });

        this.loadingTable = false;
        this.validasiData3();
        this.$vs.loading.close();
      } catch (error) {
        console.log(error);
        this.loadingTable = false;
        this.$vs.loading({ text: "error: hubungi developer" });
      }
    },
    async validasiData2() {
      //cek kode Barang nya
      try {
        this.$vs.notify({
          text: "Validation 2",
          color: "success",
          title: this.$t("berhasil"),
          iconPack: "feather",
          icon: "icon-check",
          time: 4000,
        });

        this.$vs.loading({
          text: "Mohon tunggu, Melakukan validasi ke server",
        });
        this.loadingTable = true;

        let get = await this.$api.post(
          "api/v1/masterdata/barang/cekbarangall",
          this.excelData
        );
        get.data.content.forEach((e, i) => {
          if (e.status == "gagal") {
            this.excelData[e.index]["info"] = "Kode barang tidak valid";
          }
        });

        setTimeout(() => {
          this.validasiData3();
          this.loadingTable = false;
          this.$vs.loading.close();
        }, 1);
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.loading({
          text: "error: hubungi developer",
        });
      }
    },

    ExcelDateToJSDate(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);

      var fractional_day = serial - Math.floor(serial) + 0.0000001;

      var total_seconds = Math.floor(86400 * fractional_day);

      var seconds = total_seconds % 60;

      total_seconds -= seconds;

      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;

      return new Date(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds
      );
    },

    async validasiData3() {
      try {
        this.$vs.notify({
          text: "Memasuki tahap validasi 3",
          color: "success",
          title: this.$t("berhasil"),
          iconPack: "feather",
          icon: "icon-check",
          time: 4000,
        });

        this.loading = true;
        this.$vs.loading({
          text: "Mohon tunggu, sedang melaukukan validasi ke server di tahap 3",
        });

        let header = this.getUniqueListBy(this.excelData, "noAju");
        let a = JSON.parse(JSON.stringify(header));
        const headerValidasi = a.filter(
          (f) => f.noAju != undefined && f.noAju != null && f.noAju != ""
        );
        let data = [];
        for (const elm of headerValidasi) {
          let detail = this.excelData.filter((f) => f.noAju == elm.noAju);

          detail.forEach((el, i) => {
            if (el.info != "Berhasil") {
              elm["info"] = "Gagal";
            }
            el["seriBarang"] = i + 1;
          });

          elm["listDetail"] = detail;
          data.push(elm);
        }
        // console.log(data);
        // Validasi nomor aju dan dokumen ke server
        this.excelData = data;

        // let dataCek = this.excelData.filter(f => f.info == "Berhasil");
        // dataCek.forEach(e => {
        //   e.tglDokumen = new Date(e.tglDokumen);
        //   e.tglKeluar = new Date(e.tglKeluar);
        // });

        // // let invalid = dataCek.filter((f) => f.tglDokumen == "Invalid date");

        // // console.log(invalid);
        // let cek = await this.$api.post(
        //   "api/v1/delivery/cekajudokumen",
        //   dataCek
        // );

        // let gagal = cek.data.content.filter(f => f.status != "Berhasil");
        // gagal.forEach(el => {
        //   let cariIndex = this.excelData.findIndex(x => x.noAju == el.noAju);
        //   // console.log(cariIndex, el.noAju);
        //   this.excelData[cariIndex]["info"] = el.status;
        // });

        this.dataSukses = this.excelData.filter((f) => f.info == "Berhasil");
        this.dataGagal = this.excelData.filter((f) => f.info != "Berhasil");

        setTimeout(() => {
          this.$vs.loading.close();
          this.loading = false;
          this.$vs.notify({
            text: "Validasi Selesai, data siap di upload",
            color: "success",
            title: this.$t("berhasil"),
            iconPack: "feather",
            icon: "icon-check-circle",
            time: 4000,
          });
        }, 1);
      } catch (error) {
        setTimeout(() => {
          this.$vs.loading.close();
          this.$vs.loading({ text: "error:Hubungi developer" });
        }, 1);
        console.log(error);
      }
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map((item) => [item[key], item])).values()];
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "TOTAL";
          }
          if (["jmlKeluar"].includes(column.property)) {
            let a = data.reduce(function (sum, current) {
              return sum + current.jmlKeluar;
            }, 0);
            return a.toFixed(2);
          }
          if (["amount"].includes(column.property)) {
            let a = data.reduce(function (sum, current) {
              return sum + current.amount;
            }, 0);
            return a.toFixed(2);
          }
          return null;
        }),
      ];
    },

    notif(title, text, color) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text,
      });
    },
    compareValues(key, order = "asc") {
      return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          // property doesn't exist on either object
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    },
  },
  async mounted() {
    // console.log(this.XEUtils);
    this.tglInput = new Date(this.tglInput).toISOString().split("T")[0];
    var date = new Date();
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, "0");

    var day = date.getDate().toString().padStart(2, "0");

    var hour = date.getHours();
    var minutes = date.getMinutes();
    var sec = date.getSeconds();

    var seedatetime =
      "ADDIN-" + year + month + day + "-" + hour + minutes + sec;
    this.tglKeluar = year + "-" + month + "-" + day;
    this.noreg = seedatetime;
  },
};
</script>
